/* unplugin-vue-components disabled */import script from "./FeedbackInfoFailView.vue?vue&type=script&lang=tsx&setup=true"
export * from "./FeedbackInfoFailView.vue?vue&type=script&lang=tsx&setup=true"

import "./FeedbackInfoFailView.vue?vue&type=style&index=0&id=84b13d30&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84b13d30"]])

export default __exports__